import api from '../api'
import { fetchAvailableLogout } from '../../store/modules/login/actions'
import {
    getStoredAccessToken,
    isPinLoginType,
    refreshPinSession,
    shouldRefreshPinSession
} from '../../utils/authSession'

const attachAuthorizationHeader = (request) => {
    const token = getStoredAccessToken()
    if (token) {
        request.headers = request.headers ?? {}
        request.headers.Authorization = `Bearer ${token}`
    }

    return request
}

const run = (store) => {
    api.interceptors.request.use(async function (request) {
        if (isPinLoginType() && shouldRefreshPinSession()) {
            await refreshPinSession(true)
        }

        return attachAuthorizationHeader(request)
    })

    api.interceptors.response.use(function (response) {
        return response
    }, async function (error) {
        const originalRequest = error.config ?? {}
        const statusCode = error?.response?.status

        if (statusCode === 401 && isPinLoginType() && !originalRequest._retry) {
            originalRequest._retry = true

            const refreshed = await refreshPinSession(true)
            if (refreshed) {
                return api(attachAuthorizationHeader(originalRequest))
            }
        }

        if(statusCode === 401) {
            store.dispatch(fetchAvailableLogout())
        }
        return Promise.reject(error)
    })
}

const rootInterceptor = { run }

export default rootInterceptor
